import { render, staticRenderFns } from "./DeletedEvents.vue?vue&type=template&id=76c3d2c6"
import script from "./DeletedEvents.vue?vue&type=script&lang=js"
export * from "./DeletedEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports